import React from 'react'
import mainContentPrizes from '../assets/img/bih_nagrada_2026.png'
import DobitniciContent from '../components/DobitniciContent_BIH'

const MainContent = () => {

  return (
    <div>
      <article className="mainContent pb-8 bg-white">
        <div className="px-2 lg:px-14">
          <h1 className="font-bold text-2xl sm:text-3xl lg:text-4xl mb-8 lg:mb-10">I ovog proljeća Dr. Oetker nagrađuje!</h1>
          <h2 className="font-bold text-xl lg:px-14 sm:text-2xl lg:text-3xl max-w-[60ch] mx-auto mb-8 lg:mb-10">Uključite se u VELIKI NAGRADNI NATJEČAJ i osvojite Dr. Oetker poklon paket!</h2>
          <p>Svi uživamo u blagdanima i slatkim trenucima za stolom — bilo uz tradicionalne ili moderne poslastice. Kako bismo ove praznične dane učinili još zabavnijim, pripremili smo za vas veliki nagradni natječaj u kojem možete osvojiti vrijedne nagrade.</p>
          <p>U periodu trajanja nagradnog natječaja od 18. marta do 11. aprila 2026. godine, darujemo<strong> 10 friteza na vrući zrak.</strong></p>
          
         {/*} <br />
          <a href="https://www.oetker.ba/ba-bs/svijet-dekora/dobitnici-nagradnog-natjecaja" target="_blank" className="basic-button">Dobitnici nagradnog natječaja</a>*/}
        </div>
        </article>
        <div style={{ backgroundColor: '#54A246' }}>
            <div className="flex justify-center">
              <img className="mainContentPrizes" src={mainContentPrizes} alt="nagrada" />
            </div>
        </div>
        <article className="mainContent pt-12 pb-10">
          <div className="px-2 lg:px-16">
            <p><strong>Kako učestvovati?</strong></p>
            <p>U našoj kuhinji sakrili smo 5 sastojaka za recept, a na vama je da ih pronađete! Pažljivo pretražite kuhinju i otkrijte sve skrivene sastojke kako biste otkrili recept.</p>
            <p>Nakon što ih pronađete, ostvarujete pravo učešća u nagradnom natječaju tako što ćete ispuniti obrazac za prijavu koji se nalazi u nastavku.</p>
            <br />
            <p>Sretno!</p>
          </div>
      
      </article>
    </div>
  )
}

export default MainContent